/**
 * Standard video player placeholder dimensions
 */

/**
 * Dimensions for video players in drawer contexts (incident drawer, device drawer)
 */
export const DRAWER_VIDEO_PLAYER_WIDTH = '577px'
export const DRAWER_VIDEO_PLAYER_HEIGHT = '324px'

/**
 * Dimensions for video player in camera validation/testing contexts
 */
export const VALIDATION_VIDEO_PLAYER_WIDTH = '525px'
export const VALIDATION_VIDEO_PLAYER_HEIGHT = '290px'
